<template>
  <div class="task-detail-container" v-if="task">
    <div class="detail-part">
      <div class="title">任务信息</div>
      <div class="detail-kv-container">
        <div class="kv-cell">任务ID: {{ task.taskId }}</div>
        <div class="kv-cell">运行状态: {{ taskStatusFilter(task.taskStatus) }}</div>
        <div class="kv-cell">创建时间: {{ task.taskCreateTime }}</div>
        <div class="kv-cell">结束时间: {{ task.taskEndTime }}</div>
        <div class="kv-cell">等待时长: {{ task.waitTime | formatDuration }}</div>
        <div class="kv-cell">运行时长: {{ task.execTime | formatDuration }}</div>
        <div class="kv-cell">总时长: {{ task.totalTime | formatDuration }}</div>
        <div class="kv-cell">结果数: {{ task.resultNum }}</div>
      </div>
    </div>
    <a-divider />
    <div class="detail-part">
      <div class="title">站点信息</div>
      <div class="detail-kv-container">
        <div class="kv-cell">站点ID: {{ task.taskConfig.spiderId }}</div>
        <div class="kv-cell">站点名称: {{ task.taskConfig.spiderName }}</div>
        <div class="kv-cell">站点类型: {{ task.spiderClassName }}</div>
        <div class="kv-cell">部署区域: {{ deployTypeFilter(task.deployType )}}</div>
      </div>
    </div>
    <a-divider />
    <div class="detail-part">
      <div class="title">节点信息</div>
      <div class="detail-kv-container" v-if="server">
        <div class="kv-cell">服务器名: {{ server.serverHostName }}</div>
        <div class="kv-cell">IP: {{ server.serverIp }}</div>
        <div class="kv-cell">CPU使用率: {{ server.serverCpu.toFixed(2) }}%</div>
        <div class="kv-cell">内存总量: {{ server.serverMemoryTotal | toGB }} GB</div>
        <div class="kv-cell">已使用内存: {{ server.serverMemoryUsed | toGB }} GB</div>
        <div class="kv-cell">
          内存使用率: {{ ((100 * server.serverMemoryUsed) / server.serverMemoryTotal).toFixed(2) }}%
        </div>
        <div class="kv-cell">当前任务数: {{ server.serverTask }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { queryScheduleRecordInfoApi } from '@/api/Dispatch/TaskManage'
import { taskStatusOptions } from '../dict'
export default {
  data() {
    return {
      task: null,
      taskStatusOptions: taskStatusOptions
    }
  },
  computed: {
    server() {
      return this.task?.server || this.task?.serverDto
    }
  },
  filters: {
    toGB(num) {
      return (num / 1024 / 1024 / 1024).toFixed(2)
    },

    addComma(num) {
      return num
        .toString()
        .split('')
        .reverse()
        .reduce((t, c, i) => {
          if (i && i % 3 === 0) {
            return [...t, ',', c]
          } else {
            return [...t, c]
          }
        }, [])
        .reverse()
        .join('')
    }
  },
  created() {
    let { taskId, spiderId } = this.$route.query
    if (taskId) {
      this.queryScheduleRecordInfo(taskId, spiderId)
    }
  },
  methods: {
    taskStatusFilter(value) {
      let res = this.taskStatusOptions.filter((item) => item.value == value)
      if (res.length > 0) {
        return res[0].label
      } else {
        return '未知'
      }
    },

    deployTypeFilter(value) {
      if(value == 0){
        return '国内'
      }
      return '新加坡'
    },
    async queryScheduleRecordInfo(taskId, spiderId) {
      this.loading = true
      let res = await queryScheduleRecordInfoApi({ taskId, spiderId })
      this.loading = false
      let { code, msg, extra } = res
      if (code == '200') {
        this.task = extra.task
      } else {
        this.$message.error(msg)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.task-detail-container {
  padding-bottom: 40px;
  padding-top: 10px;

  .detail-part {
    width: 100%;

    .title {
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      font-weight: 700;
      margin-bottom: 16px;
    }

    .detail-kv-container {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .kv-cell {
        line-height: 34px;
        width: 33%;
        word-break: break-all;
        overflow: hidden;
      }
    }
  }
}
</style>
